<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">autorenew</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ data.titulo }}</h2>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" mat-dialog-close>
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    @if (isCicloAlterado) {
        <app-alert-card type="warning" class="d-block mb-3">
            As fórmulas que dependem umas das outras mudaram. Confirme por onde o cálculo começa.
        </app-alert-card>
    }

    <app-alert-card type="info" class="d-block mb-3">
        @if (isVariosInicios) {
            Estas fórmulas dependem umas das outras e nenhuma sozinha resolve. Escolha quais começam o cálculo, na ordem em que são calculadas: cada uma começa sem o valor do outro tributo, e as demais seguem a ordem do cálculo.
        } @else {
            Estas fórmulas dependem umas das outras. Escolha qual é calculada primeiro: ela começa sem o valor do outro tributo, e as demais seguem a ordem do cálculo.
        }
    </app-alert-card>

    <div class="ciclo-vale-para mb-3"
        matTooltip="A configuração só é usada quando o cálculo envolve estas mesmas fórmulas personalizadas.">
        <span class="ciclo-vale-para-titulo">Vale para:</span>
        @for (dona of entidadesDonas; track $index) {
            <span class="status-badge" [ngClass]="classeDona(dona)">{{ rotuloDona(dona) }}</span>
        } @empty {
            <span class="ciclo-vale-para-texto">Fórmulas de modelo (vale para toda a empresa)</span>
        }
    </div>

    @if (isVariosInicios) {
        <div class="ciclo-area-titulo">Começam o cálculo</div>
    }
    <div cdkDropList #areaInicios="cdkDropList" class="ciclo-lista ciclo-lista-inicios"
        [cdkDropListData]="inicios" [cdkDropListConnectedTo]="[areaOpcoes]"
        [cdkDropListSortPredicate]="aceitarPosicaoInicio" (cdkDropListDropped)="soltar($event)">
        @for (membro of inicios; track membro.chaveVariavel; let i = $index) {
            <div cdkDrag class="ciclo-item" [cdkDragDisabled]="!isVariosInicios || inicios.length < 2">
                <app-content-card tone="info" actionsAlignment="start">
                    <div class="ciclo-card">
                        <span class="ciclo-card-icone">
                            @if (isVariosInicios && inicios.length > 1) {
                                <mat-icon cdkDragHandle class="material-symbols-outlined ciclo-alca"
                                    matTooltip="Arraste para mudar a ordem do cálculo."
                                    aria-label="Arrastar para mudar a ordem">drag_indicator</mat-icon>
                            } @else {
                                <mat-icon class="material-symbols-outlined" aria-hidden="true">play_circle</mat-icon>
                            }
                        </span>
                        <div class="ciclo-card-info">
                            <div class="ciclo-card-titulo">
                                <span class="ciclo-numero">{{ i + 1 }}</span>
                                <span class="ciclo-descricao">{{ descricaoFormula(membro) }}</span>
                                <span class="status-badge badge-verde">Começa aqui</span>
                                @if (rotuloEntidade(membro); as rotulo) {
                                    <span class="status-badge" [ngClass]="classeEntidade(membro)">{{ rotulo }}</span>
                                }
                            </div>
                            <small class="ciclo-chave">{{ membro.chaveVariavel }}</small>
                        </div>
                    </div>
                    <div contentCardActions class="ciclo-acoes">
                        <div class="ciclo-recalcular">
                            <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="recalcular[membro.chaveVariavel]">Recalcular no final</mat-slide-toggle>
                            <small>Depois que todas as fórmulas forem calculadas, esta é calculada de novo com os valores reais.</small>
                        </div>
                        @if (isVariosInicios) {
                            <button mat-icon-button type="button" class="ciclo-remover" aria-label="Remover dos inícios"
                                matTooltip="Remover dos inícios" (click)="removerInicio(membro)">
                                <mat-icon class="material-symbols-outlined">close</mat-icon>
                            </button>
                        }
                    </div>
                </app-content-card>
            </div>
        } @empty {
            <div class="ciclo-vazio">Arraste uma fórmula para cá ou use "Adicionar como início".</div>
        }
    </div>

    @if (cicloPendente) {
        <app-alert-card type="warning" class="d-block mt-2">
            Ainda há fórmulas dependendo umas das outras: escolha mais uma para começar.
        </app-alert-card>
    }

    @if (isVariosInicios && restantes.length > 0) {
        <div class="ciclo-area-titulo mt-3">Outras opções</div>
    }
    <div cdkDropList #areaOpcoes="cdkDropList" class="ciclo-lista ciclo-lista-opcoes"
        [cdkDropListData]="restantes" [cdkDropListConnectedTo]="[areaInicios]"
        [cdkDropListSortingDisabled]="true" [cdkDropListEnterPredicate]="aceitarEmOpcoes"
        (cdkDropListDropped)="soltar($event)">
        @for (membro of restantes; track membro.chaveVariavel; let i = $index) {
            <div cdkDrag class="ciclo-item">
                <app-content-card tone="neutral" actionsAlignment="start">
                    <div class="ciclo-card">
                        <span class="ciclo-card-icone">
                            <mat-icon cdkDragHandle class="material-symbols-outlined ciclo-alca"
                                [matTooltip]="isVariosInicios ? 'Arraste para a área dos inícios.' : 'Arraste para o topo para começar o cálculo por esta fórmula.'"
                                aria-label="Arrastar para os inícios">drag_indicator</mat-icon>
                        </span>
                        <div class="ciclo-card-info">
                            <div class="ciclo-card-titulo">
                                @if (!isVariosInicios) {
                                    <span class="ciclo-numero">{{ i + 2 }}</span>
                                }
                                <span class="ciclo-descricao">{{ descricaoFormula(membro) }}</span>
                                @if (rotuloEntidade(membro); as rotulo) {
                                    <span class="status-badge" [ngClass]="classeEntidade(membro)">{{ rotulo }}</span>
                                }
                            </div>
                            <small class="ciclo-chave">{{ membro.chaveVariavel }}</small>
                        </div>
                    </div>
                    <div contentCardActions>
                        <button mat-button type="button" class="btn-section" (click)="adicionarInicio(membro)">
                            <mat-icon>{{ isVariosInicios ? 'add' : 'play_arrow' }}</mat-icon>
                            {{ isVariosInicios ? 'Adicionar como início' : 'Começar por esta' }}
                        </button>
                    </div>
                </app-content-card>
            </div>
        }
    </div>

    <mat-expansion-panel class="formulas-panel mt-3">
        <mat-expansion-panel-header>
            <mat-panel-title class="formulas-titulo">Fórmulas envolvidas ({{ envolvidas.length }})</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="formulas-lista">
            @for (membro of envolvidas; track membro.chaveVariavel) {
                <div class="ciclo-envolvida">
                    <div class="ciclo-card-titulo">
                        <span class="ciclo-descricao">{{ descricaoFormula(membro) }}</span>
                        @if (rotuloEntidade(membro); as rotulo) {
                            <span class="status-badge" [ngClass]="classeEntidade(membro)">{{ rotulo }}</span>
                        }
                    </div>
                    <small class="ciclo-chave">{{ membro.chaveVariavel }}</small>
                </div>
            }
        </div>
    </mat-expansion-panel>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button type="button" class="btn-secondary" mat-dialog-close>Cancelar</button>
    <button mat-flat-button type="button" class="btn-primary" [disabled]="!podeSalvar" (click)="confirmar()">Salvar ciclo</button>
</mat-dialog-actions>
